import React, { Component } from 'react'
import { useState } from 'react'


function CopyAbleTableData({value, toCopyValue}) {
  const [copySuccess, setCopySuccess] = useState(false);

  const handleCopyClick = () => {
    navigator.clipboard.writeText(toCopyValue);
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 3000); // Reset the copy success message after 3 seconds
  };
  return (
    <td>
      {value}
      {value != null && value.length > 0 ? <button onClick={handleCopyClick}>{copySuccess ? "Copied!" : "Copy full value"}</button> : <div></div>}
    </td>
  );
}

class DeviceLogger extends Component {
  render() {
    let deviceLog = this.props.deviceLog
    // console.log("UTC: " + new Date(deviceLog.event_time).toUTCString())
    let eventTime = new Intl.DateTimeFormat("de-DE", {
        year: "numeric",
        month: "numeric",
        day: "2-digit", 
        hour:  "2-digit",
        minute: "2-digit",
       second: "2-digit"
     }
    ).format(new Date(deviceLog.event_time))
    function trimToLong(value, trimTop) {
      let max = 500 
      if(value != null && value.length > max) {
        if(trimTop) {
          return "..." + value.substr(value.length - max)
        } else {
          return value.substr(0, max)+"..."
        }
      }
      return value ?? "";
    }
    let todays_logs = deviceLog.todays_log
    let todaysLog = trimToLong(todays_logs, true)
    let pastClasses = trimToLong(deviceLog.past_classes, true)
    let errorMessage = trimToLong(deviceLog.error_message, false)

    return (
        <tr>
            <td>{deviceLog.id}</td>
            <td>{eventTime}</td>
            <td>{deviceLog.device_model}</td>
            <td>{deviceLog.username}</td>
            <td>{deviceLog.version}</td>
            <td>{deviceLog.build_number}</td>
            <CopyAbleTableData value={errorMessage} toCopyValue={deviceLog.error_message} />
            <td>{deviceLog.device_user_agent}</td>
            <td>{deviceLog.screen_resolution}</td>
            <CopyAbleTableData value={todaysLog} toCopyValue={todays_logs} />
            <td>
              {pastClasses}
            </td>
        </tr>
        )
    } 

}

export default DeviceLogger